import React, { useContext } from "react";
// import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from "../../context/DashboardContext";
import { useTutorialProgress } from "../../context/TutorialContext";
import "./windowSelector.scss";

function WindowSelector() {
  const {
    // demoOpen,
    // setDemoOpen,
    dataOpen,
    setDataOpen,
    modelsOpen,
    setModelsOpen,
    parametersOpen,
    setParametersOpen,
    fitOpen,
    setFitOpen,
    // resultsOpen,
    // setResultsOpen,
    modelData,
    loopOpen,
    setLoopOpen,
    outputsOpen,
    setOutputsOpen,
    setDemoOpen,
    setTutorialOpen,
  } = useContext(DashboardContext);
  const { monitorStateChange } = useTutorialProgress();
  // const [listForGauges, setListForGauges] = useState([]);

  // useEffect(() => {
  //   const filteredList = modelData.filter((model) => model.speqqleID === -113); //We filter only Raman
  //   setListForGauges(filteredList);
  // }, [modelData]);

  const handleLoopClick = () => {
    if (!loopOpen) {
      setLoopOpen(true);
      setOutputsOpen(false);
      setDataOpen(false);
      setModelsOpen(false);
      setParametersOpen(false);
      setFitOpen(false);
      // setResultsOpen(false);
      setDemoOpen(false);
      setTutorialOpen(false);
    } else {
      setLoopOpen((old) => !old);
    }
  };

  const handleOutputsClick = () => {
    if (!outputsOpen && loopOpen) {
      setLoopOpen(false);
      setOutputsOpen(true);
    } else {
      setOutputsOpen((old) => !old);
    }
  };

  const handleDataOpen = () => {
    if (!dataOpen && loopOpen) {
      setLoopOpen(false);
      setDataOpen(true);
    } else {
      setDataOpen((old) => !old);
    }
  };

  const handleModelsOpen = () => {
    if (!modelsOpen && loopOpen) {
      setLoopOpen(false);
      setModelsOpen(true);
    } else {
      setModelsOpen((old) => !old);
    }
  };

  const handleParametersOpen = () => {
    if (modelData.length > 0) {
      let newParametersState = false;
      if (!parametersOpen && loopOpen) {
        setLoopOpen(false);
        newParametersState = true;
      } else {
        newParametersState = !parametersOpen;
      }
      setParametersOpen(newParametersState);
      if (newParametersState) {
        monitorStateChange("parameters_window_opened", {
          modelData: modelData,
        });
      }
    } else {
      setParametersOpen(false);
    }
  };

  const handleFitOpen = () => {
    let newFitState = false;
    if (!fitOpen && loopOpen) {
      setLoopOpen(false);
      newFitState = true;
    } else {
      newFitState = !fitOpen;
    }
    setFitOpen(newFitState);
    if (newFitState) {
      monitorStateChange("fit_window_opened", {
        fitOpen: newFitState,
      });
    }
  };

  // const handleResultsOpen = () => {
  //   if (listForGauges.length > 0) {
  //     if (!resultsOpen && loopOpen) {
  //       setLoopOpen(false);
  //       setResultsOpen(true);
  //     } else {
  //       setResultsOpen((old) => !old);
  //     }
  //   } else {
  //     setResultsOpen(false);
  //   }
  // };

  return (
    <div className="windowSelector">
      <div className="switchPlatter" />
      <div className="switches">
        <div
          className={`switch${dataOpen ? " open" : ""}`}
          onClick={() => handleDataOpen()}
          id="data-switch"
        >
          Data
        </div>
        <div
          className={`switch${modelsOpen ? " open" : ""}`}
          onClick={() => handleModelsOpen()}
          id="models-switch"
        >
          Experiments
        </div>
        <div
          className={`switch${parametersOpen ? " open" : ""}${
            modelData.length > 0 ? "" : " disabled"
          }`}
          onClick={() => handleParametersOpen()}
          id="parameters-switch"
        >
          Parameters
        </div>
        <div
          className={`switch${fitOpen ? " open" : ""}`}
          onClick={() => handleFitOpen()}
          id="fit-switch"
        >
          Fit
        </div>
        {/* <div
          className={`switch${resultsOpen ? " open" : ""}${
            listForGauges.length > 0 ? "" : " disabled"
          }`}
          onClick={() => handleResultsOpen()}
          id="results-switch"
        >
          Results
        </div> */}
        <div
          className={`switch${outputsOpen ? " open" : ""}`}
          onClick={() => handleOutputsClick()}
          id="outputs-switch"
        >
          Graphs
        </div>
        <div
          className={`switch${loopOpen ? " open" : ""}`}
          onClick={() => handleLoopClick()}
          id="loop-switch"
        >
          Batch
        </div>
      </div>
    </div>
  );
}

export default WindowSelector;
